import { atomWithReset } from "jotai/utils";

export type typeformAtom = {
  isShow: boolean;
};

export const typeformAtom = atomWithReset<typeformAtom>({
  isShow: false,
});
